module.exports = __webpack_public_path__ + "static/img/battal.80de06b9.png";